import { combineReducers } from 'redux';

import {
    SEND_EMAIL_VERIFICATION_REQUEST,
    SEND_EMAIL_VERIFICATION_SUCCESS,
    SEND_EMAIL_VERIFICATION_FAILURE
} from './constants';

const fetching = (state = false, action) => {
    switch (action.type) {
        case SEND_EMAIL_VERIFICATION_REQUEST:
            return true;
        case SEND_EMAIL_VERIFICATION_SUCCESS:
        case SEND_EMAIL_VERIFICATION_FAILURE:
            return false;
        default:
            return state;
    }
};

const success = (state = false, action) => {
    switch (action.type) {
        case SEND_EMAIL_VERIFICATION_SUCCESS:
            return true;
        case SEND_EMAIL_VERIFICATION_REQUEST:
        case SEND_EMAIL_VERIFICATION_FAILURE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case SEND_EMAIL_VERIFICATION_FAILURE:
            return action.response.message;
        case SEND_EMAIL_VERIFICATION_REQUEST:
        case SEND_EMAIL_VERIFICATION_SUCCESS:
            return false;
        default:
            return state;
    }
};

const reducer = combineReducers({
    fetching,
    success,
    error
});

export default reducer;



// WEBPACK FOOTER //
// ./src/services/email-verification/reducer.js